import { render, staticRenderFns } from "./searchPanel.vue?vue&type=template&id=b97e87c6"
import script from "./searchPanel.vue?vue&type=script&lang=js"
export * from "./searchPanel.vue?vue&type=script&lang=js"
import style0 from "./searchPanel.vue?vue&type=style&index=0&id=b97e87c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports